import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getAttendance(idcurso) {
  try {
    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}attendance`, { idcurso });
    return response;

  } catch (error) {
    console.error('Error al obtener la asistencia', error);
  }
}
